import { __awaiter, __generator } from "tslib";
import axios from 'axios';
import S3FileFieldClient from 'django-s3-file-field';
function fileToText(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
            if (e.target === null || typeof e.target.result !== 'string') {
                throw new Error();
            }
            resolve(e.target.result);
        };
        reader.onerror = function (e) {
            reject();
        };
        reader.readAsText(file);
    });
}
export function multinetAxiosInstance(config) {
    var axiosInstance = axios.create(config);
    var Proto = Object.getPrototypeOf(axiosInstance);
    Proto.logout = function () {
        this.get('user/logout');
    };
    Proto.userInfo = function () {
        return this.get('users/me');
    };
    Proto.workspaces = function () {
        return this.get('workspaces/');
    };
    Proto.getWorkspacePermissions = function (workspace) {
        return this.get("workspaces/" + workspace + "/permissions/");
    };
    Proto.getCurrentUserWorkspacePermissions = function (workspace) {
        return this.get("workspaces/" + workspace + "/permissions/me/");
    };
    Proto.setWorkspacePermissions = function (workspace, permissions) {
        return this.put("workspaces/" + workspace + "/permissions/", permissions);
    };
    Proto.searchUsers = function (username) {
        return this.get('users/search', {
            params: {
                username: username,
            },
        });
    };
    Proto.tables = function (workspace, options) {
        if (options === void 0) { options = {}; }
        return this.get("workspaces/" + workspace + "/tables/", {
            params: options,
        });
    };
    Proto.table = function (workspace, table, options) {
        if (options === void 0) { options = {}; }
        return this.get("workspaces/" + workspace + "/tables/" + table + "/rows/", {
            params: options,
        });
    };
    Proto.networks = function (workspace) {
        return this.get("workspaces/" + workspace + "/networks/");
    };
    Proto.network = function (workspace, network) {
        return this.get("workspaces/" + workspace + "/networks/" + network + "/");
    };
    Proto.nodes = function (workspace, network, options) {
        if (options === void 0) { options = {}; }
        return this.get("workspaces/" + workspace + "/networks/" + network + "/nodes/", {
            params: options,
        });
    };
    Proto.edges = function (workspace, network, options) {
        if (options === void 0) { options = {}; }
        return this.get("workspaces/" + workspace + "/networks/" + network + "/edges/", {
            params: options,
        });
    };
    Proto.networkTables = function (workspace, network, type) {
        if (type === void 0) { type = 'all'; }
        return this.get("workspaces/" + workspace + "/networks/" + network + "/tables/", { params: { type: type } });
    };
    Proto.createWorkspace = function (workspace) {
        return this.post("workspaces/", {
            name: workspace,
        });
    };
    Proto.deleteWorkspace = function (workspace) {
        return this.delete("workspaces/" + workspace + "/");
    };
    Proto.renameWorkspace = function (workspace, name) {
        return this.put("workspaces/" + workspace + "/", {
            name: name,
        });
    };
    Proto.uploadTable = function (workspace, table, options) {
        return __awaiter(this, void 0, void 0, function () {
            var data, edgeTable, columnTypes, s3ffClient, fieldValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = options.data, edgeTable = options.edgeTable, columnTypes = options.columnTypes;
                        s3ffClient = new S3FileFieldClient({
                            baseUrl: this.defaults.baseURL + "/s3-upload/",
                            apiConfig: this.defaults,
                        });
                        return [4 /*yield*/, s3ffClient.uploadFile(data, 'api.Upload.blob')];
                    case 1:
                        fieldValue = _a.sent();
                        return [2 /*return*/, this.post("workspaces/" + workspace + "/uploads/csv/", {
                                field_value: fieldValue.value,
                                edge: edgeTable,
                                table_name: table,
                                columns: columnTypes,
                            })];
                }
            });
        });
    };
    Proto.downloadTable = function (workspace, table) {
        return this.get("workspaces/" + workspace + "/tables/" + table + "/download");
    };
    Proto.deleteTable = function (workspace, table) {
        return this.delete("workspaces/" + workspace + "/tables/" + table + "/");
    };
    Proto.columnTypes = function (workspace, table) {
        return this.get("workspaces/" + workspace + "/tables/" + table + "/annotations/");
    };
    Proto.uploadNetwork = function (workspace, network, options) {
        return __awaiter(this, void 0, void 0, function () {
            var type, data, s3ffClient, fieldValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = options.type, data = options.data;
                        s3ffClient = new S3FileFieldClient({
                            baseUrl: this.defaults.baseURL + "/s3-upload/",
                            apiConfig: this.defaults,
                        });
                        return [4 /*yield*/, s3ffClient.uploadFile(data, 'api.Upload.blob')];
                    case 1:
                        fieldValue = _a.sent();
                        return [2 /*return*/, this.post("workspaces/" + workspace + "/uploads/" + type + "/", {
                                field_value: fieldValue.value,
                                network_name: network,
                            })];
                }
            });
        });
    };
    Proto.createNetwork = function (workspace, network, options) {
        return this.post("workspaces/" + workspace + "/networks/", {
            name: network,
            edge_table: options.edgeTable,
        });
    };
    Proto.deleteNetwork = function (workspace, network) {
        return this.delete("workspaces/" + workspace + "/networks/" + network + "/");
    };
    Proto.aql = function (workspace, payload) {
        return this.post("workspaces/" + workspace + "/aql/", payload);
    };
    Proto.downloadNetwork = function (workspace, network) {
        return this.get("workspaces/" + workspace + "/networks/" + network + "/download");
    };
    Proto.uploads = function (workspace) {
        return this.get("workspaces/" + workspace + "/uploads/");
    };
    return axiosInstance;
}
//# sourceMappingURL=axios.js.map